/**
 * External dependencies
 */
import { View } from 'react-native';

const ToolbarContainer = ( { children } ) => <View>{ children }</View>;

export default ToolbarContainer;
